import EventSubscriber from './EventSubscriber';
import Event from './AppEvent';
import ArrayHandler from '../handlers/ArrayHandler';

export default class EventPublisher {

	private static instance: EventPublisher = new EventPublisher();
	private subscribers: EventSubscriber[] = [];

	private constructor () {
	}

	public static getInstance () {
		return this.instance;
	}

	public async publish (event: Event) {
		for (let subscriber of this.subscribers) {
			await subscriber.processEvent(event);
		}
	}

	public subscribe (subscriber: EventSubscriber) {
		if (ArrayHandler.includes(this.subscribers, subscriber)) {
			return;
		}

		this.subscribers.push(subscriber);
	}

	public unsubscribe (subscriber: EventSubscriber) {
		ArrayHandler.remove(this.subscribers, subscriber);
	}
}


// WEBPACK FOOTER //
// ./code/foundation/events/EventPublisher.ts